import React, { useEffect, useRef, useState } from 'react';
import { motion, useInView } from 'framer-motion';

const Index = ({
  firstHeading,
  secondHeading,
  _class,
  _secondHeading,
  subTitle,
  headingThree,
  headingTwo,
  headingOne,
  _spanClass,
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.25 });
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768); // Standard mobile breakpoint
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  // Replace <br> with space for mobile, keep actual <br/> for desktop
  const processHeading = (content) => {
    if (!content) return '';
    return isMobile
      ? content.replace(/<br\s*\/?>/gi, ' ')
      : content.replace(/<br\s*\/?>/gi, ' <br/> ');
  };

  const processedHeading = secondHeading ? processHeading(secondHeading) : '';

  // Decide heading level
  const HeadingComponent = headingOne
    ? 'h1'
    : headingTwo
    ? 'h2'
    : headingThree
    ? 'h3'
    : 'h2';

  // Split words and <br/> tags separately
  const parts = processedHeading
    ? processedHeading.split(/(<br\s*\/?>)/gi)
    : [];

  // Framer Motion variants
  const containerVariants = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.1 } },
  };

  const wordVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <>
      {(firstHeading || secondHeading || subTitle) && (
        <div className={`title ${_class}`} ref={ref}>
          {/* Small Heading */}
          {firstHeading && (
            <span
              className={`miniheading ${_spanClass}`}
              data-aos="zoom-in"
              data-aos-offset="100"
              data-aos-duration="500"
              data-aos-once="true"
              data-aos-easing="ease-in-sine"
              dangerouslySetInnerHTML={{ __html: firstHeading }}
            />
          )}

          {/* Main Animated Heading */}
          {processedHeading && (
            <motion.div
              className={`heading headingColor ${_secondHeading}`}
              variants={containerVariants}
              initial="hidden"
              animate={isInView ? 'visible' : 'hidden'}
            >
              <HeadingComponent>
                {parts.map((part, index) =>
                  part.match(/<br\s*\/?>/i) ? (
                    <br key={index} />
                  ) : (
                    <motion.span
                      key={index}
                      variants={wordVariants}
                      style={{ display: 'inline-block' }}
                      dangerouslySetInnerHTML={{
                        __html: part,
                      }}
                    />
                  )
                )}
              </HeadingComponent>
            </motion.div>
          )}

          {/* Subtitle */}
          {subTitle && (
            <p
              className="col-12 float-start mb-0"
              data-aos="fade-up"
              data-aos-offset="50"
              data-aos-duration="800"
              data-aos-once="true"
              data-aos-easing="ease-in-sine"
              dangerouslySetInnerHTML={{ __html: subTitle }}
            />
          )}
        </div>
      )}
    </>
  );
};

export default Index;
